export const FORMALITIES_HERO_IMAGE = 'motivation-formalities-security-hero.jpg'
export const SECTION_FIRST_TITLE = 'LANDING_FORMALITIES_SECURITY_GUIDELINES.SECTION_FIRST'
export const SECTION_SECOND_TITLE = 'LANDING_FORMALITIES_SECURITY_GUIDELINES.SECTION_SECOND'
export const SECTION_THIRD_TITLE = 'LANDING_FORMALITIES_SECURITY_GUIDELINES.SECTION_THIRD'
export const SECTION_FOURTH_TITLE = 'LANDING_FORMALITIES_SECURITY_GUIDELINES.SECTION_FOURTH'
export const BASE_CLASS = 'mt-LandingFormalitiesSecurityGuidelines'

export const HERO_TITLE = 'LANDING_FORMALITIES_SECURITY_GUIDELINES.HERO_TITLE'
export const HERO_DESCRIPTION = 'LANDING_FORMALITIES_SECURITY_GUIDELINES.HERO_DESCRIPTION'
